import { useFetchDashboardData } from '../use-fetch-dashboard';
import { useAverageRating } from './charts/use-average-rating';
import { useReviewsByQrCodes } from './charts/use-reviews-by-qr-codes';
import { useReviewsDistribution } from './charts/use-reviews-distribution';
import { useReviewsDistributionByTime } from './charts/use-reviews-distribution-by-time';
import { useTopNegativeLocations } from './charts/use-top-negative-locations';
import { useTopPositiveLocations } from './charts/use-top-positive-locations';

export const useDashboardReviews = () => {
  useFetchDashboardData([
    'feedback_average_rating',
    'feedbacks_by_category',
    'qrs_with_positive_feedbacks',
    'qrs_with_negative_feedbacks',
    'feedbacks_by_time',
    'feedbacks_by_qr',
  ]);

  return {
    chartData: [
      useAverageRating(),
      useReviewsDistribution(),
      useTopPositiveLocations(),
      useTopNegativeLocations(),
      useReviewsDistributionByTime(),
      useReviewsByQrCodes(),
    ],
  };
};
